// Deprecated. Please refrain from new usage
import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Card, withStyles, CardContent, CardActions } from "@material-ui/core";

import CardHeaderWithTopRight from "./CardHeaderWithTopRight";

const styles = (theme) => {
  const mobile = theme.breakpoints.down("sm");
  const desktop = theme.breakpoints.up("md");
  return {
    root: {
      display: "flex",
      justifyContent: "center",
      margin: "20px 0",
      maxHeight: "calc(100vh - 100px)",
      [mobile]: {
        width: "100%",
      },
      [desktop]: {
        width: "100vw",
      },
    },
    paper: {
      padding: "20px 10px",
      position: "relative",
      [mobile]: {
        width: "calc(100% - 10px)",
      },
      [desktop]: {
        width: 450,
      },
    },
    footer: {
      position: "absolute",
      bottom: 10,
      left: 10,
    },
    cardContent: {
      margin: "0 6px",
    },
  };
};

const CenterWidget = (props) => {
  const { classes, children, title, style, footer } = props;
  return (
    <div className={classes.root} style={style}>
      <Card className={classes.paper} elevation={1}>
        {title && <CardHeaderWithTopRight title={title} />}
        <CardContent classes={{ root: classes.cardContent }}>{children}</CardContent>
        {footer && (
          <CardActions
            classes={{
              root: classes.footer,
            }}
          >
            {footer}
          </CardActions>
        )}
      </Card>
    </div>
  );
};

export default withTranslation("common")(withStyles(styles)(CenterWidget));

CenterWidget.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  style: PropTypes.object,
  footer: PropTypes.node,
};

CenterWidget.defaultProps = {
  title: null,
  style: null,
  footer: null,
};
